import React, { MouseEventHandler } from "react";
import { Link } from "react-router-dom";
import { Button } from "@careevolution/design-system";
import LocalizedText from "../presentational/LocalizedText";
import { IdentityServerReloginState, LoginLink } from "./types";

interface ExternalLoginProps {
  reloginState: string;
  lastLoginLink: LoginLink;
  isLoading: boolean;
  loginExternal: MouseEventHandler<HTMLButtonElement>;
  subActionLink: string;
}

const ExternalLogin: React.FC<ExternalLoginProps> = ({ reloginState, lastLoginLink, isLoading, loginExternal, subActionLink }) => {
  return (
    <form className="login-action">
      {reloginState !== IdentityServerReloginState.None ?
        (<p><LocalizedText textKey="participant-login-external-info" /></p>)
        : (<h1><LocalizedText textKey="participant-login-login-title" /></h1>)
      }
      {
        !isLoading && (
          <Button
            onClick={loginExternal}
            className="primary-action"
            width="100%"
            type="submit"
          >
            <LocalizedText
              textKey="participant-login-signin-external"
              values={{ externalIdentityProviderName: lastLoginLink.Name }} />
          </Button>
        )
      }
      {
        isLoading && (
          <div className="loading-indicator" ng-show="loading"><i className="fa fa-refresh fa-spin"></i></div>
        )
      }
      <p className="sub-action"><Link to={subActionLink}><LocalizedText textKey="participant-login-external-different-method" /></Link></p>
    </form>
  )
}

export default ExternalLogin